export default "__VITE_ASSET__B5bSm7Dv__"